import { MOODLE } from '~/consts';

export const state = () => ({
  data: null,
  loading_import: false
})

export const mutations = {
  setState(state, {key, val}) {
    state[key] = val;
  },
  setSection(state, {sectionid, key, val}) {
    state.data.contents['sections'] = collect(state.data.contents.sections).map((s) => {
      if (s.sectionid == sectionid) {
        s[key] = val;
      }

      return s;
    }).toArray();
  }
}

export const actions = {
  import({ state, commit }, id) {
    const vm = this;

    commit('setState', {key: 'loading_import', val: true});

    this.$axios.post(MOODLE.IMPORT, {media_id: id}).then(({ data }) => {
      if (data.applicationSystem.code == 0) {
        commit('setState', {key: 'data', val: data.data});
      } else {
        toast.danger(data.applicationSystem.message);
      }

      commit('setState', {key: 'loading_import', val: false});
    }).catch(({ response }) => {
      commit('setState', {key: 'loading_import', val: false});
    });
  },
}
